export const FOOTER = {
  pt: {
    planTitle: {
      t1: "Escolha o seu plano",
    },
    footerTitle: {
      t1: "Ainda não decidiu?",
      t2: "Expanda o seu conhecimento sobre o mercado imobiliário",
      action: "Registe-se gratuitamente",
    },
    product: {
      title: "Para o dia-a-dia",
      valuations: "Estudos de mercado",
      metasearch: "Prospeção",
      insights: "Estatísticas de mercado",
      website: "Website Pro",
      digitalValuer: "Avaliador online",
    },
    solutions: {
      title: "Automação",
      portfolio: "Gestão de portfólio",
      risk: "Análise de risco",
      opportunities: "Encontre oportunidades",
      avms: "Customização de AVMs",
      observatory: "Observatório de dados",
    },
    company: {
      title: "Empresa",
      about: "Sobre nós",
      careers: "Carreiras",
      cases: "Indústrias",
    },
    help: {
      title: "Ajuda",
      contact: "Contacto",
    },
    countries: "Reino Unido - Espanha - Portugal",
    terms: "Termos",
    privacy: "Privacidade",
  },
  en: {
    planTitle: {
      t1: "Choose the subscription plan that best suits your business needs",
    },
    footerTitle: {
      t1: "Still undecided?",
      t2: "Try our advanced tools for free and take your market knowledge to the next level",
      action: "Sign up for free",
    },
    product: {
      title: "Essentials",
      valuations: "Valuations",
      metasearch: "Metasearch",
      insights: "Market insights",
      website: "Website Pro",
      digitalValuer: "Digital valuer",
    },
    solutions: {
      title: "Automation",
      portfolio: "Portfolio management",
      risk: "Risk analysis",
      opportunities: "Find opportunities",
      avms: "Valuation solutions",
      observatory: "Data observatory",
    },
    company: {
      title: "Company",
      about: "About",
      careers: "Careers",
      cases: "Use cases",
    },
    help: {
      title: "Help",
      contact: "Contact",
    },
    countries: "United Kingdom - Spain - Portugal",
    terms: "Terms",
    privacy: "Privacy",
  },
  es: {
    planTitle: {
      t1: "Elija su plan",
    },
    footerTitle: {
      t1: "¿A qué está esperando?",
      t2: "Obtenga la mejor herramienta del mercado inmobiliario",
      action: "Pruebe nuestra aplicación",
    },
    product: {
      title: "Para el día a día",
      valuations: "Valoraciones",
      metasearch: "Buscador inmobiliario",
      insights: "Estadísticas",
      website: "Sitio web profesional",
      digitalValuer: "Valorador digital",
    },
    solutions: {
      title: "Automatización",
      portfolio: "Portafolio",
      risk: "Riesgo",
      opportunities: "Encuentre oportunidades",
      avms: "AVMs hechos a la medida",
      observatory: "Observatorio",
    },
    company: {
      title: "Empresa",
      about: "Sobre nosotros",
      careers: "Carreras",
      cases: "Industrias",
    },
    help: {
      title: "Ayuda",
      contact: "Contacto",
    },
    countries: "Reino Unido - España - Portugal",
    terms: "Términos",
    privacy: "Privacidad",
  },
};
